// AUTO-GENERATED by `bundle exec rake access_control:generate_ts_catalog`. Do not edit manually.

export const PERMISSION_CATALOG = [
  { resource: 'access_control:endpoint_catalog', action: 'read', key: 'access_control:endpoint_catalog:read' },
  { resource: 'access_control:permissions_admin', action: 'read', key: 'access_control:permissions_admin:read' },
  { resource: 'access_control:permissions_admin', action: 'update', key: 'access_control:permissions_admin:update' },
  { resource: 'account:cancellation_status', action: 'update', key: 'account:cancellation_status:update' },
  { resource: 'account:pricing', action: 'update', key: 'account:pricing:update' },
  { resource: 'account:referral_code', action: 'update', key: 'account:referral_code:update' },
  { resource: 'account:suspension_status', action: 'update', key: 'account:suspension_status:update' },
  { resource: 'account_list', action: 'read', key: 'account_list:read' },
  { resource: 'admin_dispatch', action: 'read', key: 'admin_dispatch:read' },
  { resource: 'admin_dispatch', action: 'update', key: 'admin_dispatch:update' },
  { resource: 'auction', action: 'read', key: 'auction:read' },
  { resource: 'auction', action: 'update', key: 'auction:update' },
  { resource: 'availability_admin', action: 'read', key: 'availability_admin:read' },
  { resource: 'availability_admin', action: 'update', key: 'availability_admin:update' },
  { resource: 'billing', action: 'read', key: 'billing:read' },
  { resource: 'billing', action: 'update', key: 'billing:update' },
  { resource: 'claims', action: 'read', key: 'claims:read' },
  { resource: 'claims', action: 'update', key: 'claims:update' },
  { resource: 'collections', action: 'read', key: 'collections:read' },
  { resource: 'collections', action: 'update', key: 'collections:update' },
  { resource: 'comms_catalog_export', action: 'read', key: 'comms_catalog_export:read' },
  { resource: 'customer_impersonation', action: 'create', key: 'customer_impersonation:create' },
  { resource: 'customer_ticket', action: 'read', key: 'customer_ticket:read' },
  { resource: 'customer_ticket', action: 'update', key: 'customer_ticket:update' },
  { resource: 'cx_inbox', action: 'read', key: 'cx_inbox:read' },
  { resource: 'cx_inbox', action: 'update', key: 'cx_inbox:update' },
  { resource: 'dispatch_management', action: 'read', key: 'dispatch_management:read' },
  { resource: 'dispatch_management', action: 'update', key: 'dispatch_management:update' },
  { resource: 'dispatcher_request', action: 'create', key: 'dispatcher_request:create' },
  { resource: 'dispatcher_request', action: 'read', key: 'dispatcher_request:read' },
  { resource: 'dispatcher_request', action: 'update', key: 'dispatcher_request:update' },
  { resource: 'dispatching', action: 'read', key: 'dispatching:read' },
  { resource: 'dispatching', action: 'update', key: 'dispatching:update' },
  { resource: 'engineering_tools', action: 'read', key: 'engineering_tools:read' },
  { resource: 'engineering_tools', action: 'update', key: 'engineering_tools:update' },
  { resource: 'facility', action: 'create', key: 'facility:create' },
  { resource: 'facility', action: 'read', key: 'facility:read' },
  { resource: 'facility', action: 'update', key: 'facility:update' },
  { resource: 'feature_flag', action: 'read', key: 'feature_flag:read' },
  { resource: 'feature_flag', action: 'update', key: 'feature_flag:update' },
  { resource: 'field:return_item_disposal', action: 'update', key: 'field:return_item_disposal:update' },
  { resource: 'hiring', action: 'read', key: 'hiring:read' },
  { resource: 'hiring', action: 'update', key: 'hiring:update' },
  { resource: 'hrs_config', action: 'read', key: 'hrs_config:read' },
  { resource: 'hrs_config', action: 'update', key: 'hrs_config:update' },
  { resource: 'item_category_management', action: 'read', key: 'item_category_management:read' },
  { resource: 'item_category_management', action: 'update', key: 'item_category_management:update' },
  { resource: 'landing_content', action: 'read', key: 'landing_content:read' },
  { resource: 'landing_content', action: 'update', key: 'landing_content:update' },
  { resource: 'leads', action: 'read', key: 'leads:read' },
  { resource: 'leads', action: 'update', key: 'leads:update' },
  { resource: 'logistics', action: 'read', key: 'logistics:read' },
  { resource: 'logistics', action: 'update', key: 'logistics:update' },
  { resource: 'marketing', action: 'read', key: 'marketing:read' },
  { resource: 'marketing', action: 'update', key: 'marketing:update' },
  { resource: 'order:return_subtype', action: 'update', key: 'order:return_subtype:update' },
  { resource: 'partnerships:partner', action: 'create', key: 'partnerships:partner:create' },
  { resource: 'partnerships:partner', action: 'read', key: 'partnerships:partner:read' },
  { resource: 'partnerships:partner', action: 'update', key: 'partnerships:partner:update' },
  { resource: 'partnerships:user', action: 'create', key: 'partnerships:user:create' },
  { resource: 'partnerships:user', action: 'update', key: 'partnerships:user:update' },
  { resource: 'pricing_config', action: 'read', key: 'pricing_config:read' },
  { resource: 'pricing_config', action: 'update', key: 'pricing_config:update' },
  { resource: 'pto_admin', action: 'read', key: 'pto_admin:read' },
  { resource: 'pto_admin', action: 'update', key: 'pto_admin:update' },
  { resource: 'scheduler_supply', action: 'create', key: 'scheduler_supply:create' },
  { resource: 'self_storage', action: 'read', key: 'self_storage:read' },
  { resource: 'self_storage', action: 'update', key: 'self_storage:update' },
  { resource: 'set_schedule', action: 'read', key: 'set_schedule:read' },
  { resource: 'set_schedule', action: 'update', key: 'set_schedule:update' },
  { resource: 'shift', action: 'read', key: 'shift:read' },
  { resource: 'shift', action: 'update', key: 'shift:update' },
  { resource: 'sop_document', action: 'read', key: 'sop_document:read' },
  { resource: 'sop_document', action: 'update', key: 'sop_document:update' },
  { resource: 'staff_ticket', action: 'create', key: 'staff_ticket:create' },
  { resource: 'staff_ticket', action: 'read', key: 'staff_ticket:read' },
  { resource: 'staff_ticket', action: 'update', key: 'staff_ticket:update' },
  { resource: 'team', action: 'create', key: 'team:create' },
  { resource: 'team', action: 'read', key: 'team:read' },
  { resource: 'team', action: 'update', key: 'team:update' },
  { resource: 'ticket_management_config', action: 'read', key: 'ticket_management_config:read' },
  { resource: 'ticket_management_config', action: 'update', key: 'ticket_management_config:update' },
  { resource: 'time_clock', action: 'read', key: 'time_clock:read' },
  { resource: 'training_upload', action: 'create', key: 'training_upload:create' },
  { resource: 'training_upload', action: 'read', key: 'training_upload:read' },
  { resource: 'training_upload', action: 'update', key: 'training_upload:update' },
  { resource: 'user:password_reset', action: 'create', key: 'user:password_reset:create' },
  { resource: 'user', action: 'read', key: 'user:read' },
  { resource: 'user', action: 'update', key: 'user:update' },
  { resource: 'user_skill', action: 'read', key: 'user_skill:read' },
  { resource: 'user_skill', action: 'update', key: 'user_skill:update' },
  { resource: 'vehicle', action: 'create', key: 'vehicle:create' },
  { resource: 'vehicle', action: 'read', key: 'vehicle:read' },
  { resource: 'vehicle:status', action: 'update', key: 'vehicle:status:update' },
  { resource: 'vehicle', action: 'update', key: 'vehicle:update' },
  { resource: 'warehouse_ops', action: 'create', key: 'warehouse_ops:create' },
  { resource: 'warehouse_ops', action: 'read', key: 'warehouse_ops:read' },
  { resource: 'warehouse_ops', action: 'update', key: 'warehouse_ops:update' },
  { resource: 'workforce_impersonation', action: 'create', key: 'workforce_impersonation:create' },
] as const;

export type PermissionCatalogKey = (typeof PERMISSION_CATALOG)[number]['key'];

export type PermissionResource = (typeof PERMISSION_CATALOG)[number]['resource'];

export const PERMISSION_ACTION = {
  create: 'create',
  read: 'read',
  update: 'update',
} as const;

export type PermissionAction = (typeof PERMISSION_ACTION)[keyof typeof PERMISSION_ACTION];

export const ACCESS_CONTROL_ENDPOINT_CATALOG = {
  resource: 'access_control:endpoint_catalog',
  actions: {
    read: 'read',
  } as const,
  keys: {
    read: 'access_control:endpoint_catalog:read',
  } as const,
} as const;

export const ACCESS_CONTROL_PERMISSIONS_ADMIN = {
  resource: 'access_control:permissions_admin',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'access_control:permissions_admin:read',
    update: 'access_control:permissions_admin:update',
  } as const,
} as const;

export const ACCOUNT_CANCELLATION_STATUS = {
  resource: 'account:cancellation_status',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'account:cancellation_status:update',
  } as const,
} as const;

export const ACCOUNT_PRICING = {
  resource: 'account:pricing',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'account:pricing:update',
  } as const,
} as const;

export const ACCOUNT_REFERRAL_CODE = {
  resource: 'account:referral_code',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'account:referral_code:update',
  } as const,
} as const;

export const ACCOUNT_SUSPENSION_STATUS = {
  resource: 'account:suspension_status',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'account:suspension_status:update',
  } as const,
} as const;

export const ACCOUNT_LIST = {
  resource: 'account_list',
  actions: {
    read: 'read',
  } as const,
  keys: {
    read: 'account_list:read',
  } as const,
} as const;

export const ADMIN_DISPATCH = {
  resource: 'admin_dispatch',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'admin_dispatch:read',
    update: 'admin_dispatch:update',
  } as const,
} as const;

export const AUCTION = {
  resource: 'auction',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'auction:read',
    update: 'auction:update',
  } as const,
} as const;

export const AVAILABILITY_ADMIN = {
  resource: 'availability_admin',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'availability_admin:read',
    update: 'availability_admin:update',
  } as const,
} as const;

export const BILLING = {
  resource: 'billing',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'billing:read',
    update: 'billing:update',
  } as const,
} as const;

export const CLAIMS = {
  resource: 'claims',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'claims:read',
    update: 'claims:update',
  } as const,
} as const;

export const COLLECTIONS = {
  resource: 'collections',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'collections:read',
    update: 'collections:update',
  } as const,
} as const;

export const COMMS_CATALOG_EXPORT = {
  resource: 'comms_catalog_export',
  actions: {
    read: 'read',
  } as const,
  keys: {
    read: 'comms_catalog_export:read',
  } as const,
} as const;

export const CUSTOMER_IMPERSONATION = {
  resource: 'customer_impersonation',
  actions: {
    create: 'create',
  } as const,
  keys: {
    create: 'customer_impersonation:create',
  } as const,
} as const;

export const CUSTOMER_TICKET = {
  resource: 'customer_ticket',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'customer_ticket:read',
    update: 'customer_ticket:update',
  } as const,
} as const;

export const CX_INBOX = {
  resource: 'cx_inbox',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'cx_inbox:read',
    update: 'cx_inbox:update',
  } as const,
} as const;

export const DISPATCH_MANAGEMENT = {
  resource: 'dispatch_management',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'dispatch_management:read',
    update: 'dispatch_management:update',
  } as const,
} as const;

export const DISPATCHER_REQUEST = {
  resource: 'dispatcher_request',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'dispatcher_request:create',
    read: 'dispatcher_request:read',
    update: 'dispatcher_request:update',
  } as const,
} as const;

export const DISPATCHING = {
  resource: 'dispatching',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'dispatching:read',
    update: 'dispatching:update',
  } as const,
} as const;

export const ENGINEERING_TOOLS = {
  resource: 'engineering_tools',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'engineering_tools:read',
    update: 'engineering_tools:update',
  } as const,
} as const;

export const FACILITY = {
  resource: 'facility',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'facility:create',
    read: 'facility:read',
    update: 'facility:update',
  } as const,
} as const;

export const FEATURE_FLAG = {
  resource: 'feature_flag',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'feature_flag:read',
    update: 'feature_flag:update',
  } as const,
} as const;

export const FIELD_RETURN_ITEM_DISPOSAL = {
  resource: 'field:return_item_disposal',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'field:return_item_disposal:update',
  } as const,
} as const;

export const HIRING = {
  resource: 'hiring',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'hiring:read',
    update: 'hiring:update',
  } as const,
} as const;

export const HRS_CONFIG = {
  resource: 'hrs_config',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'hrs_config:read',
    update: 'hrs_config:update',
  } as const,
} as const;

export const ITEM_CATEGORY_MANAGEMENT = {
  resource: 'item_category_management',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'item_category_management:read',
    update: 'item_category_management:update',
  } as const,
} as const;

export const LANDING_CONTENT = {
  resource: 'landing_content',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'landing_content:read',
    update: 'landing_content:update',
  } as const,
} as const;

export const LEADS = {
  resource: 'leads',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'leads:read',
    update: 'leads:update',
  } as const,
} as const;

export const LOGISTICS = {
  resource: 'logistics',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'logistics:read',
    update: 'logistics:update',
  } as const,
} as const;

export const MARKETING = {
  resource: 'marketing',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'marketing:read',
    update: 'marketing:update',
  } as const,
} as const;

export const ORDER_RETURN_SUBTYPE = {
  resource: 'order:return_subtype',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'order:return_subtype:update',
  } as const,
} as const;

export const PARTNERSHIPS_PARTNER = {
  resource: 'partnerships:partner',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'partnerships:partner:create',
    read: 'partnerships:partner:read',
    update: 'partnerships:partner:update',
  } as const,
} as const;

export const PARTNERSHIPS_USER = {
  resource: 'partnerships:user',
  actions: {
    create: 'create',
    update: 'update',
  } as const,
  keys: {
    create: 'partnerships:user:create',
    update: 'partnerships:user:update',
  } as const,
} as const;

export const PRICING_CONFIG = {
  resource: 'pricing_config',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'pricing_config:read',
    update: 'pricing_config:update',
  } as const,
} as const;

export const PTO_ADMIN = {
  resource: 'pto_admin',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'pto_admin:read',
    update: 'pto_admin:update',
  } as const,
} as const;

export const SCHEDULER_SUPPLY = {
  resource: 'scheduler_supply',
  actions: {
    create: 'create',
  } as const,
  keys: {
    create: 'scheduler_supply:create',
  } as const,
} as const;

export const SELF_STORAGE = {
  resource: 'self_storage',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'self_storage:read',
    update: 'self_storage:update',
  } as const,
} as const;

export const SET_SCHEDULE = {
  resource: 'set_schedule',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'set_schedule:read',
    update: 'set_schedule:update',
  } as const,
} as const;

export const SHIFT = {
  resource: 'shift',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'shift:read',
    update: 'shift:update',
  } as const,
} as const;

export const SOP_DOCUMENT = {
  resource: 'sop_document',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'sop_document:read',
    update: 'sop_document:update',
  } as const,
} as const;

export const STAFF_TICKET = {
  resource: 'staff_ticket',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'staff_ticket:create',
    read: 'staff_ticket:read',
    update: 'staff_ticket:update',
  } as const,
} as const;

export const TEAM = {
  resource: 'team',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'team:create',
    read: 'team:read',
    update: 'team:update',
  } as const,
} as const;

export const TICKET_MANAGEMENT_CONFIG = {
  resource: 'ticket_management_config',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'ticket_management_config:read',
    update: 'ticket_management_config:update',
  } as const,
} as const;

export const TIME_CLOCK = {
  resource: 'time_clock',
  actions: {
    read: 'read',
  } as const,
  keys: {
    read: 'time_clock:read',
  } as const,
} as const;

export const TRAINING_UPLOAD = {
  resource: 'training_upload',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'training_upload:create',
    read: 'training_upload:read',
    update: 'training_upload:update',
  } as const,
} as const;

export const USER = {
  resource: 'user',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'user:read',
    update: 'user:update',
  } as const,
} as const;

export const USER_PASSWORD_RESET = {
  resource: 'user:password_reset',
  actions: {
    create: 'create',
  } as const,
  keys: {
    create: 'user:password_reset:create',
  } as const,
} as const;

export const USER_SKILL = {
  resource: 'user_skill',
  actions: {
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    read: 'user_skill:read',
    update: 'user_skill:update',
  } as const,
} as const;

export const VEHICLE = {
  resource: 'vehicle',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'vehicle:create',
    read: 'vehicle:read',
    update: 'vehicle:update',
  } as const,
} as const;

export const VEHICLE_STATUS = {
  resource: 'vehicle:status',
  actions: {
    update: 'update',
  } as const,
  keys: {
    update: 'vehicle:status:update',
  } as const,
} as const;

export const WAREHOUSE_OPS = {
  resource: 'warehouse_ops',
  actions: {
    create: 'create',
    read: 'read',
    update: 'update',
  } as const,
  keys: {
    create: 'warehouse_ops:create',
    read: 'warehouse_ops:read',
    update: 'warehouse_ops:update',
  } as const,
} as const;

export const WORKFORCE_IMPERSONATION = {
  resource: 'workforce_impersonation',
  actions: {
    create: 'create',
  } as const,
  keys: {
    create: 'workforce_impersonation:create',
  } as const,
} as const;
